// extracted by mini-css-extract-plugin
module.exports = {"viewMoreSection":"vnTeDD_YSSX8zHC0mb1R","viewMore":"avOwMtZahZUKb6qKE1Rv"};